import(/* webpackMode: "eager" */ "/vercel/path0/web-app/src/app/blog/page.tsx");
